import { MAG_LABELS, MAG_ANCHORS } from '../lib/scoring'
import { ScaleIcon, SCALE_FILLS } from './ScaleIcons'

/** "That many grains of sand would fill…" — one picturable object per order of magnitude. */
export function ScaleGauge({ exp, compact }: { exp: number | null; compact?: boolean }) {
  if (exp == null) return <div className={'gauge empty' + (compact ? ' compact' : '')}><div className="tiny">every notch is ten times more</div></div>
  return (
    <div className={'gauge' + (compact ? ' compact' : '')}>
      <div className="gauge-icon"><ScaleIcon exp={exp} size={compact ? 54 : 120} /></div>
      <div className="gauge-text">
        <div className="tiny">{MAG_LABELS[exp]} grains of sand fill</div>
        <div className="gauge-fill">{SCALE_FILLS[exp]}</div>
        {!compact && <div className="gauge-anchor">≈ {MAG_ANCHORS[exp]}</div>}
      </div>
    </div>
  )
}
